import { safeFetch } from "../utils/safeFetch";

function authHeaders(token, tenant) {
  return {
    Authorization: `Bearer ${token}`,
    "x-tenant-id": tenant,
  };
}

export async function getAuditLogs({ token, tenant, filters = {}, page = 1, limit = 20 }) {
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("limit", String(limit));

  if (filters.action) params.set("action", filters.action);
  if (filters.entity) params.set("entity", filters.entity);
  if (filters.userId) params.set("userId", String(filters.userId));
  if (filters.startDate) params.set("startDate", filters.startDate);
  if (filters.endDate) params.set("endDate", filters.endDate);

  const res = await safeFetch(`/api/logs?${params.toString()}`, {
    headers: authHeaders(token, tenant),
  }, `audit_logs_${params.toString()}`);

  if (!res.ok) {
    throw new Error(`HTTP error! status: ${res.status}`);
  }

  return res.json();
}

export async function exportAuditLogsCsv({ token, tenant, filters = {}, page = 1, pageSize = 200 }) {
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("pageSize", String(pageSize));

  if (filters.action) params.set("action", filters.action);
  if (filters.entity) params.set("entity", filters.entity);
  if (filters.userId) params.set("userId", String(filters.userId));
  if (filters.startDate) params.set("startDate", filters.startDate);
  if (filters.endDate) params.set("endDate", filters.endDate);

  const response = await fetch(`/api/logs/csv?${params.toString()}`, {
    headers: authHeaders(token, tenant),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = `audit-logs-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.URL.revokeObjectURL(url);
}

export async function canViewLogs({ token, tenant }) {
  const res = await safeFetch("/api/logs?page=1&limit=1", {
    headers: authHeaders(token, tenant),
  });
  return res.ok;
}
